export default __webpack_public_path__ + "static/media/coding.c92441ad.svg";